import { useEffect, useState } from "react";

const messages = [
  "Analyzing your product...",
  "Understanding your brand...",
  "Generating campaign ideas...",
  "Creating ad variations...",
  "Optimizing for conversions...",
];

const ThinkingAnimation = () => {
  const [currentMessage, setCurrentMessage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessage((prev) => (prev + 1) % messages.length);
    }, 1200);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center py-12 space-y-6">
      {/* Animated dots */}
      <div className="flex items-center gap-2">
        <div className="w-3 h-3 bg-blue-600 rounded-full animate-[pulse_1s_ease-in-out_infinite]" />
        <div className="w-3 h-3 bg-blue-600 rounded-full animate-[pulse_1s_ease-in-out_0.2s_infinite]" />
        <div className="w-3 h-3 bg-blue-600 rounded-full animate-[pulse_1s_ease-in-out_0.4s_infinite]" />
      </div>
      
      {/* Rotating message */}
      <p className="text-lg text-muted-foreground animate-fade-in transition-all duration-300">
        {messages[currentMessage]}
      </p>
    </div>
  );
};

export default ThinkingAnimation;
